import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-employees",
  templateUrl: "./employees.component.html",
  styleUrls: ["./employees.component.scss"],
  standalone: false,
})
export class EmployeesComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
